import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { Helmet } from 'react-helmet-async';
import { connect } from 'react-redux';

import deadlink from '../../resources/deadlink.svg';
import { getEnv } from '../utils/env';

import * as pageNotFound from './PageNotFound.module.css';

class PageNotFound extends PureComponent {
    handleClickIDPorten = () => {
        this.props.onClickIDPorten(this.props.idroute);
    };

    handleClickGrunnvann = () => {
        this.props.onClickGrunnvann(this.props.gvroute);
    };

    render() {
        return (
            <div className={pageNotFound.container}>
                <Helmet>
                    <title>Side ikke funnet – Granada WebReg</title>
                </Helmet>
                <img alt={''} src={deadlink} />
                <h1 className={pageNotFound.header}>{'404'}</h1>
                <p className={pageNotFound.explainer}>
                    <div>
                        <strong>{'Vi finner ikke siden.'}</strong>
                    </div>
                    {'Siden kan være flyttet, slettet eller den finnes ikke.'}
                </p>
                <div className={pageNotFound.buttoncontainer}>
                    <button className={pageNotFound.button} onClick={this.handleClickGrunnvann}>
                        {'Gå til grunnvann.no'}
                    </button>
                    <div className={pageNotFound.divider}>
                        <button className={pageNotFound.button} onClick={this.handleClickIDPorten}>
                            {'Logg inn med ID-Porten'}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

PageNotFound.propTypes = {
    idroute: PropTypes.string,
    gvroute: PropTypes.string,
    onClickIDPorten: PropTypes.func.isRequired,
    onClickGrunnvann: PropTypes.func.isRequired,
};

PageNotFound.defaultProps = {
    idroute: `${getEnv('API_URL')}/service/DB8E0709-EBBD-465D-94B4-5FA677DDE390/authentication/signin`,
    gvroute: 'http://www.grunnvanninorge.no/',
};

const mapStateToProps = () => ({});

const mapDispatchToProps = () => ({
    onClickIDPorten: (idroute) => {
        window.location.href = idroute;
    },
    onClickGrunnvann: (gvroute) => {
        window.location.href = gvroute;
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(PageNotFound);
